import * as i0 from "@angular/core";
export class CommonService {
    constructor() { }
    isIOSdevice() {
        return /iPad|iPhone|iPod/.test(navigator.userAgent);
    }
}
CommonService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CommonService_Factory() { return new CommonService(); }, token: CommonService, providedIn: "root" });
